/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseActionContextRequest } from './ResponseActionContextRequest';
import {
    ResponseActionContextRequestFromJSON,
    ResponseActionContextRequestFromJSONTyped,
    ResponseActionContextRequestToJSON,
    ResponseActionContextRequestToJSONTyped,
} from './ResponseActionContextRequest';

/**
 * 
 * @export
 * @interface ResponseActionPreviewRequest
 */
export interface ResponseActionPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof ResponseActionPreviewRequest
     */
    actionId?: string;
    /**
     * 
     * @type {ResponseActionContextRequest}
     * @memberof ResponseActionPreviewRequest
     */
    context?: ResponseActionContextRequest;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ResponseActionPreviewRequest
     */
    parameters?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ResponseActionPreviewRequest interface.
 */
export function instanceOfResponseActionPreviewRequest(value: object): value is ResponseActionPreviewRequest {
    return true;
}

export function ResponseActionPreviewRequestFromJSON(json: any): ResponseActionPreviewRequest {
    return ResponseActionPreviewRequestFromJSONTyped(json, false);
}

export function ResponseActionPreviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseActionPreviewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'actionId': json['actionId'] == null ? undefined : json['actionId'],
        'context': json['context'] == null ? undefined : ResponseActionContextRequestFromJSON(json['context']),
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
    };
}

export function ResponseActionPreviewRequestToJSON(json: any): ResponseActionPreviewRequest {
    return ResponseActionPreviewRequestToJSONTyped(json, false);
}

export function ResponseActionPreviewRequestToJSONTyped(value?: ResponseActionPreviewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actionId': value['actionId'],
        'context': ResponseActionContextRequestToJSON(value['context']),
        'parameters': value['parameters'],
    };
}

